import React from 'react';

const servicesData = [
  {
    name: 'Data preparation',
    icon: 'fas fa-trash-alt',
    description: 'Cleaning and structuring data for analysis'
  },
  {
    name: 'Transformation & ETL',
    icon: 'fas fa-sync-alt',
    description: 'Building efficient data pipelines'
  },
  {
    name: 'SQL database',
    icon: 'fas fa-database',
    description: 'Database design and optimization'
  },
  {
    name: 'Data visualisation',
    icon: 'fas fa-chart-line',
    description: 'Creating insightful dashboards'
  },
  {
    name: 'Flow automation',
    icon: 'fas fa-cogs',
    description: 'Automating business processes'
  },
  {
    name: 'Predictive analytics',
    icon: 'fas fa-chart-area',
    description: 'Advanced analytics and forecasting'
  },
];

const Services = () => {
  return (
    <div className="section skills-container bg-white" id="services">
      <div className="container">
        <div className="row" style={{ marginBottom: '50px' }}>
          <div className="col-lg-6 col-md-12 text-wrapper">
            <h4 className="section-heading-left">OUR SERVICES</h4>
            <h2 className="section-subtitle-left">From raw data to real results</h2>
            <p>
              Whether you're looking for quick improvements or a long-term analytics partner, we help transform disconnected data into reliable insights. 
              Our services cover the full analytics journey, from data cleaning and pipeline automation to dashboard design and predictive analysis.
            </p>
          </div>

          <div className="col-lg-6 col-md-12 d-none d-lg-flex image-wrapper">
            <img src="assets/img/illustration/21.png" alt="Data Illustration" className="skills-image" />
          </div>
        </div>

        <div className="services-grid">
          {servicesData.map((service, index) => (
            <div key={index} className="service-box">
              <div className="text-content">
                <h3 className="heading-left">{service.name}</h3>
                <p>{service.description}</p>
              </div>
              <i className={service.icon}></i>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services; 